const steps = [
  {
    phase: "PHASE 01",
    title: "Select Your Plan",
    body: "Choose monthly renewal or permanent lifetime access and lock in your order reference on this page.",
  },
  {
    phase: "PHASE 02",
    title: "Save Payment Receipt",
    body: "Store your instant payment invoice number and unique verification string after checkout.",
  },
  {
    phase: "PHASE 03",
    title: "Verify in Discord",
    body: "Submit your receipt and order reference for verification, role assignment and files download.",
  },
];

const Steps = () => {
  return (
    <section data-testid="steps-section" className="py-24 px-6 border-b border-red-500/20">
      <div className="max-w-6xl mx-auto">
        <div className="mb-14">
          <p className="font-mono-x text-xs text-[#ff4655] uppercase tracking-widest mb-1">Automated Delivery</p>
          <h2 className="font-display text-5xl uppercase text-white">How To Get Your Models</h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {steps.map((s, i) => (
            <div
              key={s.phase}
              data-testid={`step-card-${i + 1}`}
              className="p-6 bg-zinc-900/60 border-l-2 border-[#ff4655] hover:bg-zinc-900 transition-colors"
            >
              <div className="font-mono-x text-[#ff4655] text-xs font-bold mb-2">{s.phase}</div>
              <h3 className="text-white font-bold text-lg uppercase mb-2">{s.title}</h3>
              <p className="text-zinc-400 text-xs leading-relaxed">{s.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Steps;
